import api from './api';

export interface CompanyInfo {
  orgCode: string;
  companyName: string;
  dlpUseYn: string;
  nacUseYn: string;
  aptUseYn: string;
}

export const companyService = {
  getAll: async (): Promise<CompanyInfo[]> => {
    const response = await api.get<CompanyInfo[]>('/company');
    return response.data;
  },

  getByPageType: async (pageType: 'DLP' | 'NAC' | 'APT' | 'DAILY_REPORT' | 'WEB_FILTER' | 'EDR_REPORT' | 'EDR_THREAT'): Promise<CompanyInfo[]> => {
    const response = await api.get<CompanyInfo[]>(`/company/page-type/${pageType}`);
    return response.data;
  },
};

